<!--
  巡检任务管理：标准查询列表（根 div + avue-crud 事件链 + publicOption）。左侧「启动定时任务」等业务按钮放在 menuLeft。
-->
<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      :permission="permissionList"
      :before-open="beforeOpen"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <table-column-set :THIS_TO_PARENT="this" slot="menuRight" />
      <!-- 左侧菜单按钮 -->
      <template slot="menuLeft">
        <el-button type="primary" icon="el-icon-timer" size="small" @click="handleCreateTodayTasks" :loading="createTaskLoading">
          启动定时任务
        </el-button>
        <el-button type="primary" icon="el-icon-download" size="small" :loading="exportLoading" @click="handleExport">
          导出
        </el-button>
      </template>

      <!-- 自定义工单编号列 -->
      <template slot="workOrderId" slot-scope="{ row }">
        <el-button type="text" @click="handleViewDetail(row)" style="color: #409eff">
          {{ row.workOrderId }}
        </el-button>
      </template>

      <!-- 自定义状态列 -->
      <template slot="orderStatus" slot-scope="{ row }">
        <el-tag :type="getStatusButtonType(row.orderStatus)" size="small" effect="light">
          <i :class="getStatusIcon(row.orderStatus)"></i> {{ getStatusText(row.orderStatus) }}
        </el-tag>
      </template>

      <!-- 自定义进度列 -->
      <template slot="progress" slot-scope="{ row }">
        <div class="progress-container">
          <div class="progress-info">
            <span class="progress-text">
              <span class="completed-count">{{ row.completedPointCount }}</span>
              <span class="separator">/</span>
              <span class="total-count">{{ row.planPointCount }}</span>
            </span>
            <el-progress :percentage="
                getProgressPercentage(
                  row.completedPointCount,
                  row.planPointCount
                )
              " :color="
                getProgressColor(row.completedPointCount, row.planPointCount)
              " :show-text="false" :stroke-width="8" class="progress-bar" />
          </div>
        </div>
      </template>

      <!-- 自定义操作列 -->
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" icon="el-icon-view" @click="handleView(row)" style="color: #409eff; margin-right: 8px">
          查看
        </el-button>
        <el-button
          v-if="Number(row.orderStatus) === 0"
          type="text"
          size="small"
          icon="el-icon-delete"
          @click="rowDel(row)"
          style="color: #f56c6c"
        >
          删除
        </el-button>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { searchTimeConfig } from "@/basic-common/util/common";
import {
  getList,
  add,
  update,
  remove,
  getDetail,
  createTodayTasks,
  exportExcel,
} from "./api";
import { downloadXls } from "@/util/util";

export default {
  name: "dispatched-inspection-task-manage",
  mixins: [crudMixins],
  data () {
    return {
      apiConfig: { getList, add, update, remove, getDetail },
      defaultParams: {
        businessType: "inspection-task",
      },
      createTaskLoading: false,
      exportLoading: false,
      option: {
        ...this.$store.state.publicOption,
        stripe: true,
        menu: true,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        viewBtn: false,
        menuWidth: 160,
        menuAlign: "center",
        searchBtn: true,
        searchResetBtn: true,
        searchMenuSpan: 6,
        column: [
          {
            label: "工单编号",
            prop: "workOrderId",
            align: "center",
            overHidden: true,
            slot: true,
            search: true,
            searchPlaceholder: "请输入任务编号",
            searchSpan: 6,
          },
          {
            label: "计划名称",
            prop: "extPlanId",
            align: "center",
            overHidden: true,
            search: true,
            searchPlaceholder: "请选择计划名称",
            searchSpan: 6,
            type: "select",
            dicUrl:
              "/api/produce/inspection-worko-rder/select/page/plan-info",
            props: { label: "extPlanName", value: "extPlanId" },
            dicFormatter: (res) => {
              return res.records || res.data || [];
            },
          },
          {
            label: "执行周期",
            prop: "executeCycle",
            align: "center",
            overHidden: true,
            formatter: (row) => {
              const cycleMap = {
                1: "每天",
                2: "每周",
                3: "每月",
                4: "自定义",
              };
              return cycleMap[row.executeCycle] || "未知";
            },
          },
          {
            label: "巡检路线",
            prop: "inspectionRouteCode",
            align: "center",
            overHidden: true,
            search: true,
            searchPlaceholder: "请选择巡检路线",
            searchSpan: 6,
            type: "select",
            dicUrl:
              "/api/produce/inspection-worko-rder/select/page/router-info",
            props: { label: "inspectionRouteName", value: "inspectionRouteCode" },
            dicFormatter: (res) => {
              return res.records || res.data || [];
            },
          },
          {
            label: "计划时间",
            prop: "planTime",
            align: "center",
            overHidden: true,
            slot: true,
            formatter: (row) => {
              return row.cycleStartTime + '~' + row.cycleEndTime;
            },
          },
          {
            label: "执行时间",
            prop: "actualTime",
            align: "center",
            overHidden: true,
            slot: true,
            formatter: (row) => {
              return (row.actualStartTime || '--') + (row.actualEndTime ? '~' + row.actualEndTime : '');
            },
          },
          {
            label: "巡检人员",
            prop: "planPersonNames",
            align: "center",
            overHidden: true,
            search: true,
            searchPlaceholder: "请选择巡检人员",
            searchSpan: 6,
            type: "select",
            remote: true,
            filterable: true,
            dicUrl:
              "/api/produce/base-workorderuser/select/distinct/pycode?realName={{key}}",
            props: { label: "realName", value: "id" },
            dicFormatter: (res) => {
              return res.records || res.data || [];
            },
          },
          {
            label: "状态",
            prop: "orderStatus",
            align: "center",
            overHidden: true,
            slot: true,
            search: true,
            searchPlaceholder: "请选择任务状态",
            searchSpan: 6,
            type: "select",
            // dicData: [
            //   { label: "待执行", value: "0" },
            //   { label: "执行中", value: "1" },
            //   { label: "已完成", value: "2" },
            //   { label: "已超时", value: "3" },
            // ],
            dataType: 'string',
            dicData: this.$store.getters.commonDict['inspection_order_satus'],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: "进度",
            prop: "progress",
            align: "center",
            overHidden: true,
            slot: true,
          },
          {
            label: "创建时间",
            prop: "createTime",
            align: "center",
            overHidden: true,
            slot: true,
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
            hide: true,
          },
        ],
      },
    };
  },
  methods: {
    async handleExport () {
      this.exportLoading = true;
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query));
        const res = await exportExcel(params);
        downloadXls(res.data, `巡检任务管理_${Date.now()}.xlsx`);
        this.$message.success("导出成功");
      } catch (e) {
        console.warn(e);
        this.$message.error((e && e.message) || "导出失败");
      } finally {
        this.exportLoading = false;
      }
    },

    // 启动定时任务 - 创建今日任务
    handleCreateTodayTasks () {
      this.$confirm('确认启动定时任务，创建今日的巡检任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.createTaskLoading = true;
        createTodayTasks().then(res => {
          this.$message.success('定时任务启动成功，今日任务已创建');
          // 刷新列表
          this.onLoad(this.page);
        }).catch(error => {
          console.error('启动定时任务失败:', error);
        }).finally(() => {
          this.createTaskLoading = false;
        });
      }).catch(() => {
        // 用户取消
      });
    },

    // 获取状态按钮类型
    getStatusButtonType (status) {
      const typeMap = {
        0: "info",
        1: "primary",
        2: "success",
        3: "danger",
        4: "danger",
      };
      return typeMap[status] || "info";
    },

    // 获取状态图标
    getStatusIcon (status) {
      const iconMap = {
        0: "el-icon-time",
        1: "el-icon-user",
        2: "el-icon-check",
        3: "el-icon-warning",
        4: "el-icon-warning",
      };
      return iconMap[status] || "el-icon-time";
    },

    // 获取状态文本
    getStatusText (status) {
      const textMap = {
        0: "待执行",
        1: "执行中",
        2: "已完成",
        3: "已超时",
        4: "未执行",
      };
      return textMap[status] || "未知";
    },

    // 获取进度百分比
    getProgressPercentage (completed, total) {
      if (!total || total === 0) return 0;
      return Math.round((completed / total) * 100);
    },

    // 获取进度条颜色
    getProgressColor (completed, total) {
      const percentage = this.getProgressPercentage(completed, total);
      if (percentage === 100) return "#67c23a";
      if (percentage >= 50) return "#409eff";
      return "#e6a23c";
    },
    // 工单编号点击进详情（与「查看」一致）
    handleViewDetail (row) {
      this.handleView(row);
    },
    // 查看详情
    handleView (row) {
      this.$router.push(
        `/dispatched-personnel-track/InspectionTaskManage/detail/${row.id}`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;

  .progress-info {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;

    .progress-text {
      display: flex;
      align-items: center;
      font-size: 14px;
      min-width: 50px;

      .completed-count {
        color: #67c23a;
        font-weight: 600;
      }

      .separator {
        color: #909399;
        margin: 0 2px;
      }

      .total-count {
        color: #909399;
      }
    }

    .progress-bar {
      flex: 1;
      min-width: 100px;
    }
  }
}

::v-deep .el-progress {
  .el-progress-bar__outer {
    background-color: #f5f7fa;
    border-radius: 10px;
  }

  .el-progress-bar__inner {
    border-radius: 10px;
    transition: width 0.6s ease;
  }
}
</style>
